import React from 'react';
import PrescripteurFormProvider from '../../providers/PrescripteurFormProvider';
import CreatePrescripteurStepper from './CreatePrescripteurStepper';

const CreatePrescripteurCRM: React.FunctionComponent = function () {
    return (
        <PrescripteurFormProvider>
            <CreatePrescripteurStepper />
        </PrescripteurFormProvider>
    );
};

export default CreatePrescripteurCRM;
